import React from 'react';
import AdminDashboardComponent from './admin-dashboard.component';

function AdminDashboard() {
    return <AdminDashboardComponent />;
}

export default AdminDashboard;
